import React from "react";
import { Popover } from "antd";
import "./truncatedtext.css";

const TruncatedText = ({ text }) => {
  const maxLength = 40;
  const isTruncated = text?.length > maxLength;
  const truncatedText = isTruncated ? text.slice(0, maxLength) + "..." : text;

  if (!isTruncated) {
    return <span>{text}</span>;
  }

  return (
    <Popover
      content={<div className="truncated-text">{text}</div>}
      placement="bottomRight"
      trigger="hover"
      overlayClassName="actioncard-popover"
    >
      <span>{truncatedText}</span>
    </Popover>
  );
};

export default TruncatedText;
